module.exports = __webpack_public_path__ + "img/24.7.Chla.5f3abfe0.png";